import React, { Component } from 'react'
import Mainsec from '../coursetemplate/mainsec'
import Syllabus from '../coursetemplate/syllabus'
import Coursereview from '../coursetemplate/Course-review'
import Overview from '../coursetemplate/overview'
import Coursefeature from '../coursetemplate/coursefeature'
import Batchtime from '../coursetemplate/batchtime'
import Relatedcourse from '../coursetemplate/other-course'
import LearnSoftLogo from '../coursetemplate/CourseLogo'
import CourseEligibility from '../coursetemplate/Course-Eligibility'
import EnrollnowBox from '../coursetemplate/enroll-box'
import Faqs from '../coursetemplate/faq'
import NewMainsec from '../coursetemplate/new-mainsec'
export default class Azureadmintemplate extends Component {
 
  render() {
    const course =[
      {title:"AZ-104: Microsoft Azure Administrator",
      content:[],
    },
    {    title: "Introduction to Azure Administration",    content: [      "Overview of Azure and its services",      "Understanding Azure resource management",      "Creating and managing Azure subscriptions",      "Navigating the Azure portal and Azure CLI",      "Azure documentation and support resources"    ]
  },
  {
    title: "Azure Virtual Machines",
    content: [
      "Creating and managing virtual machines",
      "Virtual machine storage options",
      "Networking for virtual machines",
      "Virtual machine backups and disaster recovery",
      "Managing Azure virtual machine images"
    ]
  },
  {
    title: "Azure Storage",
    content: [
      "Azure Blob Storage",
      "Azure File Storage",
      "Azure Table Storage",
      "Azure Queue Storage",
      "Storage performance and scalability"
    ]
  },
  {
    title: "Azure Networking",
    content: [
      "Virtual networks",
      "Subnets and IP addressing",
      "Network security groups",
      "Azure DNS",
      "Azure Traffic Manager"
    ]
  },
  {
    title: "Azure Active Directory",
    content: [
      "Azure AD basics",
      "Azure AD identity management",
      "Azure AD authentication and authorization",
      "Azure AD Connect for on-premises identity management",
      "Azure AD monitoring and reporting"
    ]
  },
  {
    title: "Azure Security Center",
    content: [
      "Security Center overview",
      "Security policies",
      "Threat protection",
      "Azure Security Center recommendations",
      "Security Center monitoring and reporting"
    ]
  },
  {
    title: "Azure Monitoring and Management",
    content: [
      "Azure Monitor",
      "Azure Log Analytics",
      "Azure Automation",
      "Azure Resource Manager templates",
      "Azure Policy"
    ]
  },
  {
    title: "Azure Governance",
    content: [
      "Azure Resource Manager",
      "Azure tags",
      "Azure Blueprints",
      "Role-Based Access Control (RBAC)",
      "Azure Cost Management and Billing"
    ]
  },
  {
    title: "Azure Backup and Site Recovery",
    content: [
      "Azure Backup overview",
      "Azure Backup configuration and management",
      "Azure Site Recovery overview",
      "Azure Site Recovery configuration and management",
      "Disaster recovery scenarios"
    ]
  },
  {
    title: "Azure Migration",
    content: [
      "Azure migration options",
      "Assessing workloads for migration",
      "Migrating virtual machines",
      "Migrating databases",
      "Azure Migrate"
    ]
  },
  {
    title: "Azure Solutions",
    content: [
      "Azure App Service",
      "Azure Kubernetes Service",
      "Azure Functions",
      "Azure Logic Apps",
      "Azure API Management"
    ]
  },
  {
    title: "Azure Advanced Topics",
    content: [
      "Azure Service Fabric",
      "Azure Batch",
      "Azure Virtual Desktop",
      "Azure DevOps integration",
      "Azure IoT Hub"
    ]
  }
    ]

    const faqData = [
      {
        question: 'How does Azure admin support scalability and flexibility for businesses?',
        answer:
          'Azure admins facilitate scalable solutions, allowing businesses to adapt to changing demands and expand their operations seamlessly.',
      },
      {
        question: 'What role does Azure admin play in ensuring security and compliance?',
        answer:
          'Azure admins implement robust security measures, monitor for threats, and ensure compliance with industry regulations to safeguard data and assets.',
      },
      {
        question: '"What are the benefits of using Azure Administration?" ',
        answer:
          ' Azure Administration provides several benefits, including improved resource utilization, better security and compliance, enhanced scalability and flexibility, and reduced costs.',
      },
      {
        question: `What career opportunities are available for someone with ${this.props.title} skills?`,
        answer:
          'A person with Azure Administration skills can pursue a variety of career opportunities such as Azure Administrator, Cloud Operations Engineer, Cloud Architect, and DevOps Engineer.',
      },
      {
        question: 'Is there a certificate of completion offered for the courses on Learnsoft.org?',
        answer:
          'Yes, upon completion of a course on Learnsoft.org, students will receive a certificate of completion that can be added to their professional portfolio or resume.',
      },
    ];
    const EligibilityData=[
      {
        cnt:"Learnsoft's Azure admin training typically requires basic understanding of cloud computing concepts and familiarity with Microsoft Azure. Prerequisites may include completion of foundational Azure courses or relevant certifications. Technical background or experience in IT administration is advantageous. Educational qualifications in fields like computer science or information technology may be beneficial. Access to an Azure subscription for hands-on practice might be necessary. Specific requirements may vary based on the course level or specialization. For accurate details, consult Learnsoft's official documentation or contact their support team directly."
      },
    ]

    const ReviewData=[
      {
          img:"/course-img/course-review/learnsoft-logo.webp",
          Username:"Muthu",
          date:" Nov 09 ,2023",
          review:`The Azure Admin Training program at learnsoft.org Institute covers a comprehensive range of topics, ensuring that you are well-prepared to handle real-world cloud management scenarios. Azure Admin certification from learnsoft.org can open doors to a variety of career opportunities. It validates your expertise in using Azure Admin training in ${this.props.location} and your commitment to professional growth. With Azure Admin certification, you'll be well-prepared to tackle complex data challenges and stand out in the job market.`
      },
      { img:"/course-img/course-review/learnsoft-logo.webp",
          Username:"Lavanya",
          date:" Nov 29 ,2023",
          review:`learnsoft.org is a renowned name in Azure Admin Training in Kolkata. Our institute is dedicated to providing top-notch training with a focus on hands-on experience and practical skills. With a team of certified trainers and a commitment to excellence, learnsoft.org stands out as a reliable choice for aspiring Azure Admins.`
      },
  ]
  
    return(
      <>
          {/* <Mainsec img={this.props.url} title={this.props.title} location={this.props.location} location1={this.props.location1} intro="In the dynamic landscape of cloud computing, Microsoft Azure stands as a cornerstone, empowering businesses with a wide array of cloud services and resources. However, to harness its full potential, adept administration is paramount. This course unravels the essence of Azure administration, shedding light on its critical role in ensuring seamless operations within Azure environments."/>
             */}
          <NewMainsec rating='4.5' students={"850"} durations={"45"} img={this.props.url} title={this.props.title} location={this.props.location} location1={this.props.location1} intro="In the dynamic landscape of cloud computing, Microsoft Azure stands as a cornerstone, empowering businesses with a wide array of cloud services and resources. However, to harness its full potential, adept administration is paramount. This course unravels the essence of Azure administration, shedding light on its critical role in ensuring seamless operations within Azure environments."/>
            
            
            <Coursefeature title={this.props.title} location1={this.props.location1}/>
 <section className="pdt50">
		        <Overview heading={`${this.props.title} ${this.props.location1} - Course Overview`} content={`Azure Administration is a highly in-demand skill with a growing demand for professionals with expertise in managing Azure cloud environments. At Learnsoft.org, we offer top-notch Azure Administration training courses in ${this.props.location} to help individuals enhance their skills and gain a comprehensive understanding of Azure Administration principles and practices. Our experienced trainers use a hands-on approach, incorporating real-world scenarios and practical exercises to provide a well-rounded education. Whether you're new to Azure Administration or looking to expand your skillset, Learnsoft.org's Azure Administration ${this.props.location1} is the perfect choice to take your career to the next level. Contact us today to learn more about our courses and start your Azure Administration journey.`} 
            title={this.props.title} location={this.props.location} location1={this.props.location1} course={"Our Azure Administration course covers a wide range of topics, including Azure resource management, security, and monitoring. Our experienced trainers will guide you through hands-on exercises and real-world scenarios to help you understand the concepts and techniques used in Azure Administration. By the end of the course, you will be able to manage and secure Azure cloud environments effectively."}/>
            </section>
 <Batchtime title={this.props.title} fees="25,999" offer="15,999"/>
 <CourseEligibility heading3={`Eligibility requirements for learnsoft's ${this.props.title} Training`} EligibilityData={EligibilityData}/>
 <EnrollnowBox bgimg={"/course-img/Enroll-box-imgs/enroll-bg.webp"} heading4={`Boost Your Career Advancement: Empowering You to Reach New Heights as a ${this.props.title} Developer`}/>
 <Syllabus CurriculumData={course} title={this.props.title}/>
          <div className='df fjse mfdcr mfac'>
 <Coursereview ReviewData={ReviewData}/>
 <div className='df fjc'>
 <LearnSoftLogo/>
 </div>
 </div>
 <Faqs faqData={faqData} heading4={`Answering Your Questions about Learnsoft's ${this.props.title} Course`}/>
       <Relatedcourse location={this.props.relatedlocation} location1={this.props.location1} url1={this.props.url1}  cou5="DevOps" coupath5="devops" cou='Azure DevOps' coupath='azure-devops' cou1='Azure' coupath1='azure' cou3='Azure Solution Architect' coupath3='azure-solution-architect' cou2='Azure Developer' coupath2='azure-developer'
          cou9='Kubernetes' coupath9='kubernetes' cou8='Jenkins' coupath8='jenkins' cou7='GoCD' coupath7='gocd'
          cou10='Terraform' coupath10='terraform' cou6='Azure Data Engineering' coupath6='azure-data-engineering'  cou4='Azure Security' coupath4='azure-security' />
       
      </>
    );
  }
}
